exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "modal-detail-loan .modal-content.mobile .modal-header{margin-top:20px}modal-detail-loan .modal-content.mobile .modal-header h1{font-size:16px}modal-detail-loan .modal-content.mobile .modal-body p{font-size:13px}modal-detail-loan .modal-content.mobile .modal-body p>span{font-size:14px}modal-detail-loan .modal-header h1{color:#0072c9;font-size:24px;font-weight:400}modal-detail-loan .modal-header h1:first-letter{text-transform:uppercase}modal-detail-loan .modal-body{margin-top:20px}modal-detail-loan .modal-body p{font-size:15px}modal-detail-loan .modal-body p>span{color:#333}modal-detail-loan .modal-footer{margin-top:39px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/myLoans/modals/modalDetailLoan/modalDetailLoan.scss
// module id = 1987
// module chunks = 0